module.exports = __webpack_public_path__ + "img/200_7.0756cada.png";